import React from 'react';
import { Facebook, X, Instagram, Linkedin, MessageSquare } from 'lucide-react';

interface TenantSocialMediaProps {
  formData: any;
  handleConfigChange: (path: string, value: any) => void;
}

export const TenantSocialMedia: React.FC<TenantSocialMediaProps> = ({
  formData,
  handleConfigChange,
}) => {
  return (
    <section>
      <div className="grid grid-cols-1 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center">
            <Facebook className="h-5 w-5 text-blue-400 mr-2" /> Facebook <span className="text-gray-500 text-xs">(tenant.config.social.facebook)</span>
          </label>
          <input
            type="url"
            value={formData.config.social?.facebook || ''}
            onChange={(e) => handleConfigChange('social.facebook', e.target.value)}
            placeholder="https://facebook.com/"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center">
            <X className="h-5 w-5 text-sky-400 mr-2" /> X <span className="text-gray-500 text-xs">(tenant.config.social.x)</span>
          </label>
          <input
            type="url"
            value={formData.config.social?.x || ''}
            onChange={(e) => handleConfigChange('social.x', e.target.value)}
            placeholder="https://x.com/"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center">
            <MessageSquare className="h-5 w-5 text-pink-400 mr-2" /> TikTok <span className="text-gray-500 text-xs">(tenant.config.social.tiktok)</span>
          </label>
          <input
            type="url"
            value={formData.config.social?.tiktok || ''}
            onChange={(e) => handleConfigChange('social.tiktok', e.target.value)}
            placeholder="https://tiktok.com/@"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center">
            <MessageSquare className="h-5 w-5 text-red-600 mr-2" /> YouTube <span className="text-gray-500 text-xs">(tenant.config.social.youtube)</span>
          </label>
          <input
            type="url"
            value={formData.config.social?.youtube || ''}
            onChange={(e) => handleConfigChange('social.youtube', e.target.value)}
            placeholder="https://youtube.com/@"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center">
            <MessageSquare className="h-5 w-5 text-green-500 mr-2" /> WhatsApp <span className="text-gray-500 text-xs">(tenant.config.social.whatsapp)</span>
          </label>
          <input
            type="url"
            value={formData.config.social?.whatsapp || ''}
            onChange={(e) => handleConfigChange('social.whatsapp', e.target.value)}
            placeholder="https://wa.me/237XXXXXXXXX"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center">
            <MessageSquare className="h-5 w-5 text-pink-500 mr-2" /> Pinterest <span className="text-gray-500 text-xs">(tenant.config.social.pinterest)</span>
          </label>
          <input
            type="url"
            value={formData.config.social?.pinterest || ''}
            onChange={(e) => handleConfigChange('social.pinterest', e.target.value)}
            placeholder="https://pinterest.com/"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center">
            <MessageSquare className="h-5 w-5 text-yellow-400 mr-2" /> Snapchat <span className="text-gray-500 text-xs">(tenant.config.social.snapchat)</span>
          </label>
          <input
            type="url"
            value={formData.config.social?.snapchat || ''}
            onChange={(e) => handleConfigChange('social.snapchat', e.target.value)}
            placeholder="https://snapchat.com/add/"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center">
            <Instagram className="h-5 w-5 text-pink-400 mr-2" /> Instagram <span className="text-gray-500 text-xs">(tenant.config.social.instagram)</span>
          </label>
          <input
            type="url"
            value={formData.config.social?.instagram || ''}
            onChange={(e) => handleConfigChange('social.instagram', e.target.value)}
            placeholder="https://instagram.com/"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center">
            <Linkedin className="h-5 w-5 text-blue-500 mr-2" /> LinkedIn <span className="text-gray-500 text-xs">(tenant.config.social.linkedin)</span>
          </label>
          <input
            type="url"
            value={formData.config.social?.linkedin || ''}
            onChange={(e) => handleConfigChange('social.linkedin', e.target.value)}
            placeholder="https://linkedin.com/company/"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>
      </div>
    </section>
  );
};
